<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Khóa học: {{ modelData.name }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <chapter-index></chapter-index>
      <h3>Thông tin về khóa học:</h3>
      <div class="model-content">
        <el-col :span="24">
          <el-row :gutter="20">
            <el-col :span="9">
              <el-form label-position="left" :model="modelData" ref="createModel" label-width="160px">
                <el-form-item prop="name" label="Tên khóa học :" class="form-item">
                  <span>{{ modelData.name }}</span>
                </el-form-item>
                <el-form-item prop="price" label="Giá :" class="form-item">
                  <span style="color: red">{{ modelData.price }}</span>
                </el-form-item>
                <el-form-item prop="price" label="Giá gạch :" class="form-item">
                  <span style="color: red">{{ modelData.price_brick }}</span>
                </el-form-item>
<!--                 <el-form-item prop="date_use" label="Số ngày sử dụng :" class="form-item">
                  <span style="color: red">{{ modelData.date_use }} ngày</span>
                </el-form-item> -->
                <el-form-item prop="category_course_id" label="Lĩnh vực khóa học :" class="form-item">
                  <span>{{ modelData.category_course_text }}</span>
                </el-form-item>
                <el-form-item prop="university_id" label="Trường Đại học :" class="form-item">
                  <span>{{ modelData.university_txt }}</span>
                </el-form-item>
                <el-form-item prop="teacher_id" label="Giảng viên" class="form-item">
                  <span>{{ modelData.teacher_txt }}</span>
                </el-form-item>
                <el-form-item prop="sale" label="Phần trăm sale :" class="form-item">
                  <span>{{ modelData.sale }}</span>
                </el-form-item>
                <el-form-item prop="date_start" label="Ngày bắt đầu sale :" class="form-item input-daterange">
                  <span>{{ modelData.date_start }}</span>
                </el-form-item>
                <el-form-item prop="date_end" label="Ngày kết thúc sale :" class="form-item input-daterange">
                  <span>{{ modelData.date_end }}</span>
                </el-form-item>
                <el-form-item prop="total_lessons" label="Tổng số bài học :" class="form-item input-daterange">
                  <span>{{ modelData.total_lessons }}</span>
                </el-form-item>
                <el-form-item prop="total_time_videos_txt" label="Tổng thời gian video :" class="form-item input-daterange">
                  <span>{{ modelData.total_time_videos_txt }}</span>
                </el-form-item>
                <el-form-item label="Kích hoạt" prop="status">
                  <el-switch
                    active-color="#13ce66"
                    inactive-color="#7f8c8d"
                    disabled
                    v-model="modelData.status">
                  </el-switch>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="15">
              <el-form label-position="top" :model="modelData" ref="createModel">
                <img v-if="modelData.image_path" :src="modelData.image_path" class="course">
                <el-form-item prop="content" label="">
                  <div v-html="modelData.content"></div>
                </el-form-item>
                <el-form-item prop="video_youtube" label="Link video Youtube" class="form-item">
                  <div v-html="modelData.video_youtube"></div>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import ChapterIndex from '@/components/chapters/Index'
export default {
  name: 'CourseShow',
  metaInfo () {
    return {
      title: 'Khóa học | Xem chi tiết'
    }
  },
  components: {
    ChapterIndex
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        id: 0,
        name: '',
        category_course_id: '',
        teacher_id: '',
        image: '',
        video_youtube: '',
        image_path: '',
        price: '',
        content: '',
        sale: '',
        date_start: '',
        date_end: '',
        total_time_videos_txt: '',
        status: true
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'courses-index', text: 'Khóa học' },
        { name: 'courses-create', text: 'Xem chi tiết' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'courses-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('courses/' + this.$route.params.course_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.course {
  width: 280px;
  height: 200px;
  display: block;
}
</style>

<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/components/projects/Show.vue